import { Texture, TilingSprite } from 'pixi.js';

export default function sizeTilingSprite(
  ts: TilingSprite,
  tex: Texture,
  viewW: number,
  viewH: number,
  mode: 'cover' | 'contain' | 'fit-height' = 'fit-height'
) {
  const sx = viewW / tex.width;
  const sy = viewH / tex.height;

  const scale = mode === 'cover' ? Math.max(sx, sy) : mode === 'contain' ? Math.min(sx, sy) : /* fit-height */ sy;

  ts.tileScale.set(scale, scale);

  ts.width = viewW;
  ts.height = viewH;

  ts.tilePosition.set(0, ts.tilePosition.y);
}
